import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react";
import { useHistory } from 'react-router-dom';
import styled from "styled-components";
import lodash from 'lodash';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';

import FetchModule from "../../../../Share/Network/FetchModule";

import LeftArrow from '../../../../../image/WhiteLeftArrow.png';
import RightArrow from '../../../../../image/WhiteRightArrow.png';
import PaymentInput from "../../../../../Component/MemberComponent/PaymentInput";
import DiscountPaymentInput from "../../../../../Component/MemberComponent/DiscountPaymentInput";
import ProductCountInput from "../../../../../Component/MemberComponent/ProductCountInput";
import PointInput from "../../../../../Component/MemberComponent/PointInput";

import GrayExitPath from '../../../../../image/GrayExit.png';
import WhiteTrashIcon from '../../../../../image/WhiteTrashIcon.png';
import PaymentOptionSettingSelectBox from "../../../../../MemberRegistration/Model/PaymentOptionSettingSelectBox";
import PaymentOptionCustomInput from "../../../../../MemberRegistration/Component/PaymentOptionCustomInput";
import DiscountAmountInput from "../../../../../Component/MemberComponent/DiscountAmountInput";
import AddPaymentOptionModal from "../../../../../MemberRegistration/Model/AddPaymentOptionModal";
import { useLanguage } from '../../../../../Context/LanguageContext';

const ProductSalesAddModal = forwardRef((props, ref) => {
  const { totalPoint, clickUsageData, onRegist, onClickExit } = props;

  const history = useHistory();
  const { t } = useLanguage();

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  const [title, setTitle] = useState(t('memberDetail.productSalesModal.productSalesSelectProduct'));
  const [producs, setProducts] = useState([]);
  const [nowPage, setNowPage] = useState(1);
  const [page, setPage] = useState(1);
  const [modalWidth, setModalWidth] = useState(280);
  const [modalHeight, setModalHeight] = useState(342);
  const [productViewWidth, setProductViewWidth] = useState(200);
  const [productViewHeight, setProductViewHeight] = useState(240);
  const [productSalesWidth, setProductSalesWidth] = useState(0);
  const [productSalesHeight, setProductSalesHeight] = useState(0);
  const [clickData, setClickData] = useState(undefined);
  const [count, setCount] = useState(1);
  const [discount, setDiscount] = useState(0);
  const [notReceived, setNotReceived] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isLinkPay, setIsLinkPay] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  const ModalRef = useRef();
  const ProductRef = useRef();
  const CardPaymentRef = useRef();
  const CashPaymentRef = useRef();
  const DiscountPaymentRef = useRef();
  const PointRef = useRef();

  useImperativeHandle(ref, () => ({
    getProductData: () => {
      return clickData;
    },
    getProductId: () => {
      return clickData.id;
    },
    getProductName: () => {
      return clickData.name;
    },
    getCount: () => {
      return count;
    },
    getCardPrice: () => {
      return CardPaymentRef.current.getValue();
    },
    getCashPrice: () => {
      return CashPaymentRef.current.getValue();
    },
    getDiscountPrice: () => {
      return discount;
    },
    getNotReceivedPrice: () => {
      return notReceived;
    },
    getSelectedPaymentOptions: () => {
      return selectedPaymentOptions;
    },
    getPoint: () => {
      return PointRef.current.getValue();
    }
    // setClickData: (value) => {
    //   setClickData(value);
    //   setTitle('물품 추가하기')

    //   setModalWidth(424);
    //   setModalHeight(321);

    //   setProductViewWidth(0);
    //   setProductViewHeight(0);

    //   setProductSalesHeight(252);
    // }
  }))

  // API Call //
  useEffect(() => {
    // if (clickUsageData !== undefined) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('product/', 'GET');

        if (responseData.status === 200) {
          let list = responseData.data.slice();
          let page = Math.ceil(list.length / 8);
          let finalList = [];

          if (clickUsageData === undefined) {
            for (let i = 0; i < page; i++) {
              let newList = list.slice((i * 8), (i * 8) + 8);
              finalList.push({ list: newList });
            }

            if (list.length >= 5) {
              setModalWidth(872);
              setModalHeight(592);

              setProductViewWidth(872);
              setProductViewHeight(504);
            }
            if (list.length >= 4) {
              setModalWidth(872);
              setProductViewWidth(872);
            }
            else if (list.length >= 3) {
              setModalWidth(648);
              setProductViewWidth(648);
            }
            else if (list.length >= 2) {
              setModalWidth(424);
              setProductViewWidth(424);
            }
            else {
              setModalWidth(342);
              setProductViewWidth(200);
            }

            setPage(page);
            setProducts(finalList);

            // ModalRef.current.style.opacity = 1;
            // ModalRef.current.style.transition = `all 0.3s ease-in-out`;
            setTimeout(() => (
              ModalRef.current.style.opacity = 1,
              ModalRef.current.style.transition = `all 0.3s ease-in-out`
            ), 100)
          }
          else {
            let saledProduct = undefined;

            for (let i = 0; i < list.length; i++) {
              if (list[i].id === clickUsageData.productId) {
                saledProduct = list[i];
                break;
              }
            }

            setClickData(saledProduct);

            // CardPaymentRef.current.setValue(clickUsageData.cardPrice);
            // CashPaymentRef.current.setValue(clickUsageData.cashPrice);
            // DiscountPaymentRef.current.setValue(clickUsageData.discountPrice);
            // PointRef.current.setValue(clickUsageData.point);
            let selectedPaymentOptionLength = 0;

            if (clickUsageData.selectedPaymentOptions !== undefined && clickUsageData.selectedPaymentOptions.length > 0) {
              selectedPaymentOptionLength = clickUsageData.selectedPaymentOptions.length - 1;
              setSelectedPaymentOptions(lodash.cloneDeep(clickUsageData.selectedPaymentOptions));
            }
            else {
              let newSelectedPaymentOptions = [];

              if (clickUsageData.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: clickUsageData.cashPrice });
              if (clickUsageData.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '카드', price: clickUsageData.cardPrice });
              if (clickUsageData.point !== 0) newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: clickUsageData.point });

              if (newSelectedPaymentOptions.length > 0) {
                selectedPaymentOptionLength = newSelectedPaymentOptions.length - 1;
                setSelectedPaymentOptions(newSelectedPaymentOptions);
              }
            }
            setNotReceived(clickUsageData.notReceivedPrice);
            setDiscount(clickUsageData.discountPrice);
            setCount(clickUsageData.count);

            // 링코페이 여부 판별 //
            if (clickUsageData.merchantUid) {
              const indicator = clickUsageData.merchantUid.split('-')[2];
              if (indicator === '1' || indicator === '2') setIsLinkPay(true);
            }

            setTitle(t('memberDetail.productSalesModal.productSalesEditHistory'))

            // setModalWidth(424);
            setModalWidth(456);
            setModalHeight(321 + (63 * selectedPaymentOptionLength));

            setProductViewWidth(0);
            setProductViewHeight(0);

            setProductSalesHeight(252 + (63 * selectedPaymentOptionLength));

            setTimeout(() => (
              ModalRef.current.style.opacity = 1,
              ModalRef.current.style.transition = `all 0.3s ease-in-out`
            ), 300)
          }

          // setProducts(responseData.data);
        }
      }
    )();
  }, [clickUsageData])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // 미수금 산정하기 //
  useEffect(() => {
    if (clickData === undefined) {
      setNotReceived(0);
      return;
    }

    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price ?? 0);
    }

    if (discount !== '') totalPrice += parseInt(discount.toString().replaceAll(',', ''));

    setNotReceived(Math.max((clickData.price * count) - totalPrice, 0));
  }, [clickData, count, selectedPaymentOptions, discount]);

  // useEffect(() => {
  //   if (clickData === undefined) return;

  //   let card = CardPaymentRef.current.getValue();
  //   let cash = CashPaymentRef.current.getValue();
  //   let discount = DiscountPaymentRef.current.getValue();
  //   let point = PointRef.current.getValue();

  //   setNotReceivedPrice(((clickData.price * count) - (card + cash + discount + point)) > 0 ? ((clickData.price * count) - (card + cash + discount + point)) : 0);
  // }, [clickData, count])

  // 상품 클릭 후 사진이 있는지 확인 //
  function onCalcIsExistProductView() {
    if (clickData === undefined) return true;
    else if (clickData.picture === '') return true;
    else return false;
  }

  // 상품 클릭 후 사진표출 계산 //
  function onCalcProductView() {
    if (clickData === undefined) return '';
    else if (clickData.picture === '') return 'https://picture.link-zone.org/DefaultLogo.png';
    else return clickData.picture;
  }

  // 상품 클릭 후 이름 표출 계산 //
  function onCalcProductName() {
    if (clickData === undefined) return '';
    else return clickData.name;
  }

  // 상품 클릭 후 재고개수 표출 계산 //
  function onCalcProductInventory() {
    if (clickData === undefined) return '0';
    else return clickData.inventory.toLocaleString('ko-KR');
  }

  // 상품 클릭 후 가격 표출 계산 //
  function onCalcProductPrice() {
    if (clickData === undefined) return '0';
    else return clickData.price.toLocaleString('ko-KR');
  }

  // 상품 클릭 후 상품의 원 가격 * 개수 표출 계산 //
  function onCalcProductSalePrice() {
    if (clickData === undefined) return '0';
    else return (clickData.price * count).toLocaleString('ko-KR');
  }

  // 상품 클릭 후 상품의 결제 후 미수금 가격 표출 계산 //
  function onCalcProductNotReceivedPrice() {
    if (clickData === undefined) return '0';
    else return notReceived.toLocaleString('ko-KR');
  }

  // 다음페이지 버튼 클릭시 //
  function onClickNextPage() {
    if (nowPage < page) {
      ProductRef.current.style.transform = `translateX(-${(productViewWidth + 40) * nowPage}px)`;
      setNowPage(nowPage + 1);
    }
  }

  // 이전페이지 버튼 클릭시 //
  function onClickPrevPage() {
    if (nowPage > 1) {
      ProductRef.current.style.transform = `translateX(-${((productViewWidth + 40) * (nowPage - 2))}px)`;
      setNowPage(nowPage - 1);
    }
  }

  // 물품 클릭시 //
  function onClickProduct(data) {
    setClickData(data);
    setTitle(t('memberDetail.productSalesModal.productSalesAddProduct'))
    // setNotReceivedPrice(data.price * count);

    // setModalWidth(424);
    setModalWidth(456);
    setModalHeight(321);

    setProductViewWidth(0);
    setProductViewHeight(0);

    // setProductSalesWidth(456);
    setProductSalesHeight(252);
  }

  // 금액 입력시 미수금 정리 // 
  function changeValue() {
    if (clickData === undefined) return;

    let card = CardPaymentRef.current.getValue();
    let cash = CashPaymentRef.current.getValue();
    let discount = DiscountPaymentRef.current.getValue();
    let point = PointRef.current.getValue();

    // setTotalPrice(parseInt(card) + parseInt(cash));
    setNotReceived(((clickData.price * count) - (card + cash + discount + point)) > 0 ? ((clickData.price * count) - (card + cash + discount + point)) : 0);
  }

  // 저장하기 클릭시 //
  function onClickSave() {
    onRegist();
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }


  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('memberDetail.productSalesModal.alertEnterPaymentName'));
      return;
    }

    if (isLoading) {
      alert(t('memberDetail.productSalesModal.alertSavingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert(t('memberDetail.alertDeletingInProgress'));
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }


  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].price = value.replaceAll(',', '');

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: 0 });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
    setProductSalesHeight(252 + (63 * (newSelectedPaymentOptions.length - 1)));
    setModalHeight(321 + (63 * (newSelectedPaymentOptions.length - 1)));
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
    setProductSalesHeight(252 + (63 * (newSelectedPaymentOptions.length - 1)));
    setModalHeight(321 + (63 * (newSelectedPaymentOptions.length - 1)));
  }

  return (
    <TotalModalWrapper>
      { isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} /> }
      <Modal ref={ModalRef} isSelectView={clickData === undefined} width={modalWidth} height={modalHeight}>
        <InnerWrapper>
          <TitleWrapper width={clickData === undefined ? '100%' : '456px'}>
            <TitleTextWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color="#000000" hover='default'>{title}</Text>
              {clickData === undefined && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color="#777777" hover='default'>{t('memberDetail.productSalesModal.productSalesDesc')}</Text>}
            </TitleTextWrapper>
            <SaveButtonWrapper>
              <ExitButton onClick={onClickExit}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#3E4148' cursor='pointer'>{t('memberDetail.modalCancel')}</Text>
              </ExitButton>
              {
                clickData !== undefined &&
                <SaveButton onClick={onClickSave}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>{t('memberDetail.productSalesModal.btnSave')}</Text>
                </SaveButton>
              }
            </SaveButtonWrapper>
          </TitleWrapper>
          <ProductSelectView width={productViewWidth} height={productViewHeight}>
            {
              (clickData === undefined && page > 1) &&
              <ButtonWrapper>
                <Button onClick={onClickPrevPage} isView={nowPage > 1} style={{ marginLeft: '-70px' }} >
                  <ArrowImage style={{ marginLeft: '-4px' }} src={LeftArrow} />
                </Button>
                <Button onClick={onClickNextPage} isView={nowPage < page} style={{ marginRight: '-70px' }} >
                  <ArrowImage style={{ marginRight: '-4px' }} src={RightArrow} />
                </Button>
              </ButtonWrapper>
            }
            <TotalProductView width={productViewWidth} height={productViewHeight}>
              <ProductViewWrapper ref={ProductRef}>
                {
                  producs.map((data, index) => (
                    <ProductView key={index} width={productViewWidth}>
                      {
                        data.list.map((innerData, innerIndex) => (
                          <ProductBoxView key={innerIndex} onClick={() => onClickProduct(innerData)}>
                            <ProductImageWrapper>
                              <ProductImage isEmpty={innerData.picture === ''} src={innerData.picture === '' ? 'https://picture.link-zone.org/DefaultLogo.png' : innerData.picture} />
                            </ProductImageWrapper>
                            <ProductInfoBox>
                              <ProductInfoWrapper>
                                <ProductTextWrapper width={60} alignItems='flex-start'>
                                  <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{innerData.name}</Text>
                                </ProductTextWrapper>
                                <ProductTextWrapper width={30} alignItems='flex-end'>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesCountUnit').replace('{count}', innerData.inventory.toLocaleString('ko-KR'))}</Text>
                                </ProductTextWrapper>
                              </ProductInfoWrapper>
                              <ProductInfoWrapper>
                                <ProductTextWrapper width={20} alignItems='flex-start'>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesPrice')}</Text>
                                </ProductTextWrapper>
                                <ProductTextWrapper width={70} alignItems='flex-end'>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesPriceWon').replace('{price}', innerData.price.toLocaleString('ko-KR'))}</Text>
                                </ProductTextWrapper>
                              </ProductInfoWrapper>
                            </ProductInfoBox>
                          </ProductBoxView>
                        ))
                      }
                    </ProductView>
                  ))
                }
              </ProductViewWrapper>
            </TotalProductView>
          </ProductSelectView>
          <ProductSalesView width={productSalesWidth} height={productSalesHeight}>
            <ProductBoxView>
              <ProductImageWrapper>
                <ProductImage isEmpty={onCalcIsExistProductView()} src={onCalcProductView()} />
              </ProductImageWrapper>
              <ProductInfoBox>
                <ProductInfoWrapper>
                  <ProductTextWrapper width={60} alignItems='flex-start'>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF'>{onCalcProductName()}</Text>
                  </ProductTextWrapper>
                  <ProductTextWrapper width={30} alignItems='flex-end'>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesCountUnit').replace('{count}', onCalcProductInventory())}</Text>
                  </ProductTextWrapper>
                </ProductInfoWrapper>
                <ProductInfoWrapper>
                  <ProductTextWrapper width={20} alignItems='flex-start'>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesPrice')}</Text>
                  </ProductTextWrapper>
                  <ProductTextWrapper width={70} alignItems='flex-end'>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={15} color='#FFFFFF'>{t('memberDetail.productSalesModal.productSalesPriceWon').replace('{price}', onCalcProductPrice())}</Text>
                  </ProductTextWrapper>
                </ProductInfoWrapper>
              </ProductInfoBox>
            </ProductBoxView>
            <ProductSalesInfoBox>
              <LayerWrapper>
                <ComponentWrapper>
                  <ComponentTitle>{t('memberDetail.productSalesModal.productSalesItemPrice')}</ComponentTitle>
                  <CalcPaymentInputWrapper>
                    <CalcPaymentInput>{onCalcProductSalePrice()}</CalcPaymentInput>
                    <CalcPaymentUnit>{t('memberDetail.refundModal.won')}</CalcPaymentUnit>
                  </CalcPaymentInputWrapper>
                </ComponentWrapper>
                <ComponentWrapper>
                  <ComponentTitle>{t('memberDetail.productSalesModal.productSalesPurchaseCount')}</ComponentTitle>
                  <ProductCountInput value={count} setValue={setCount} width={77} disabled={isLinkPay} />
                </ComponentWrapper>
              </LayerWrapper>
              {
                selectedPaymentOptions.map((data, index) => (
                  <InnerLayerWrapper
                    key={'SelectedPaymentOptions-' + index}
                    marginTop={10}
                    gap={20}
                    style={{ zIndex: selectedPaymentOptions.length - index }}>
                    <InputWrapper>
                      <PaymentOptionTitleWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.productSalesModal.paymentMethod') + (index === 0 ? '' : ' ' + (index + 1))}</Text>
                        {
                          (!isLinkPay || data.name === '포인트') && index !== 0 &&
                          <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                            <DeleteIcon src={WhiteTrashIcon} />
                          </DeleteButton>
                        }
                      </PaymentOptionTitleWrapper>
                      {
                        isLinkPay && data.name !== '포인트' ?
                          <LinkoPayTextView>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#595959' cursor='default'>{t('memberDetail.productSalesModal.linkoPay')}</Text>
                          </LinkoPayTextView>
                          :
                          <PaymentOptionSettingSelectBox
                            index={index}
                            value={data}
                            setValue={onChangeSelectedPaymentOptions}
                            options={paymentOptions}
                            disabled={paymentOptions.length === 0}
                            width={111}
                            onClickAdditionOption={onClickAdditionOption}
                            onClickDeleteOption={onClickDeleteOption} />
                      }
                    </InputWrapper>
                    <InputWrapper>
                      <PaymentOptionTitleWrapper>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.productSalesModal.receivedPrice')}</Text>
                        {(data.paymentOptionId === 0 || (data.paymentOptionid === undefined && data.id === 0)) && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{totalPoint.toLocaleString('ko-KR') + 'P'}</Text>}
                      </PaymentOptionTitleWrapper>
                      <UnitInputWrapper>
                        <PaymentOptionCustomInput
                          index={index}
                          value={(data.price ?? 0).toLocaleString('ko-KR')}
                          setValue={onChangePaymentOptionPrice}
                          placeholder='0'
                          disabled={isLinkPay && data.name !== '포인트'}
                          textAlign='right'
                          width={77} />
                        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                      </UnitInputWrapper>
                    </InputWrapper>
                  </InnerLayerWrapper>
                ))
              }
              {
                !isLinkPay &&
                <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('memberDetail.productSalesModal.addPaymentOption')}</AddPaymentOptionButton>
              }
              <InnerLayerWrapper marginTop={10} gap={20}>
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.membershipAddModal.discountAmount')}</Text>
                  <UnitInputWrapper>
                    <DiscountAmountInput
                      value={discount.toLocaleString('ko-KR')}
                      setValue={setDiscount}
                      placeholder='0'
                      width={77} />
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                  </UnitInputWrapper>
                </InputWrapper>
                <InputWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{t('memberDetail.productSalesModal.productSalesUnpaid')}</Text>
                  <UnitInputWrapper>
                    <NotReceivedInputView width={77}>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#D92828' cursor='default'>{notReceived.toLocaleString('ko-KR')}</Text>
                    </NotReceivedInputView>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#D92828' cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                  </UnitInputWrapper>
                </InputWrapper>
              </InnerLayerWrapper>
              {/* <LayerWrapper style={{ marginTop: `8px` }}>
                <ComponentWrapper>
                  <ComponentTitle>카드 결제 금액</ComponentTitle>
                  <PaymentInput ref={CardPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={false} />
                </ComponentWrapper>
                <ComponentWrapper>
                  <ComponentTitle>현금 결제 금액</ComponentTitle>
                  <PaymentInput ref={CashPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={false} />
                </ComponentWrapper>
              </LayerWrapper>
              <LayerWrapper style={{ marginTop: `8px` }}>
                <ComponentWrapper>
                  <ComponentTitle>할인 금액</ComponentTitle>
                  <DiscountPaymentInput ref={DiscountPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={false} />
                </ComponentWrapper>
                <ComponentWrapper>
                  <PointTitleTextWrapper>
                    <ComponentTitle>포인트</ComponentTitle>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{totalPoint.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                  </PointTitleTextWrapper>
                  <PointInput ref={PointRef} changeFn={changeValue} width={77} placeholder={0} disabled={false} unit='P'/>
                </ComponentWrapper>
              </LayerWrapper> */}
              {/* <LayerWrapper style={{ marginTop: `8px` }}>
                <ComponentWrapper>
                  <ComponentTitle>할인 금액</ComponentTitle>
                  <DiscountPaymentInput ref={DiscountPaymentRef} changeFn={changeValue} width={77} placeholder={0} disabled={false} />
                </ComponentWrapper>
                <ComponentWrapper>
                  <ComponentTitle>미수금 금액</ComponentTitle>
                  <CalcPaymentInputWrapper>
                    <NotReceivedPaymentInput>{onCalcProductNotReceivedPrice()}</NotReceivedPaymentInput>
                    <CalcPaymentUnit>원</CalcPaymentUnit>
                  </CalcPaymentInputWrapper>
                </ComponentWrapper>
              </LayerWrapper> */}
            </ProductSalesInfoBox>
          </ProductSalesView>
        </InnerWrapper>
      </Modal>
    </TotalModalWrapper>
  )
})

export default ProductSalesAddModal;

const Modal = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding ${props => props.isSelectView ? `20px 40px` : `20px`};

  padding: 20px;

  opacity: 0;

  // min-width: 280px;
  // max-width: 956px;
  // min-width: 200px;
  // max-width: 876px;
  width: ${props => props.width}px;

  // min-height: 342px;
  // max-height: 592px;
  // min-height: 300px;
  // max-height: 592px;
  height: ${props => props.height}px;

  border-radius: 10px;
  background-color: #FFFFFF;

  // overflow: hidden;

  // transition: all 0.5s ease-in-out;
`;

const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 16px;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // width: 100%;
  width: ${props => props.width};
`;

const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 52px;
  height: 52px;

  border-radius: 52px;
  background-color: #FF8B48;

  opacity: ${props => props.isView ? 1 : 0};
  
  &:hover {
    cursor: ${props => props.isView ? `pointer` : `default`};
  }
`;

const ArrowImage = styled.img`
  width: 14px;
  height: 24px;
`;

const ProductSelectView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  overflow: hidden;
`;

const TotalProductView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  overflow: hidden;
`;

const ProductViewWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 40px;

  transition: all 0.5s ease-in-out;
`;

const ProductView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;

  gap: 24px;

  // min-width: 200px;
  // max-width: 872px;
  
  width: ${props => props.width}px;

  min-height: 240px;
  max-height: 504px;
`;

const ProductBoxView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 200px;
  height: 240px;

  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.10);
  border-radius: 24px 24px 10px 10px;
  background-color: #FFFFFF;

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const ProductSalesView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 456px;
  height: ${props => props.height}px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const ProductSalesInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 244px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const InnerLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ComponentTitle = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;
`;

const CalcPaymentInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
  margin-top: 8px;
`;

const CalcPaymentInput = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 8px 0 8px;
  margin: 0 0 0 0;

  width: 77px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #CBCBCB;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FFFFFF;
`;

const CalcPaymentUnit = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  margin: 0 0 0 0;

  color: #000000;
`;

const NotReceivedPaymentInput = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 8px 0 8px;
  margin: 0 0 0 0;

  width: 77px;
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #FFFFFF;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF3131;
`;

const ProductImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  // height: 198px;
  height: 179px;

  overflow: hidden;

  border-radius: 24px 24px 0px 0px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;

  object-fit: ${props => props.isEmpty ? `contains` : `scale-down`};
  // object-fit: cover;
`;

const ProductInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  // height: 66px;
  height: 60px;

  gap: 4px;

  border-radius: 0px 0px 10px 10px;
  background-color: #000000;
`;

const ProductInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 86.36%;
  height: 25px;
`;

const ProductTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  // justify-content: center;
  justify-content: flex-start;
  align-items: ${props => props.alignItems};

  width: ${props => props.width}%;
  height: 100%;

  overflow: hidden;
`;

const SaveButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 70px;
  height: 40px;

  border-radius: 10px;
  background-color: #F5F6F8;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #5BD98A;

  &:hover {
    cursor: pointer;
  }
`;

const PointTitleTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;


const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const NotReceivedInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0 8px;

  width: ${props => props.width}px;
  height: 30px;

  border: 1px solid #D92828;
  border-radius: 5px;
  background-color: #FFFFFF;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color #B3B3B3;
`;

const LinkoPayTextView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 111px;
  height: 30px;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 5px;
  background-color: #F2F2F2;

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #CBCBCB;

  &:hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: #EC9393;

  &:hover {
    cursor: pointer;
    background-color: #D92828;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
	font-family: ${props => props.fontFamily};
	font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;
